/**
 * Motor de sincronizacao do brinde automatico (produto-brinde R$ 0,00).
 * Nao desenha a barra: a barra (snippets/freeshipping.liquid) e renderizada em
 * Liquid dentro do carrinho. Este script so decide quando adicionar/remover o
 * brinde via Cart AJAX API e depois re-renderiza as secoes do carrinho pelo
 * mecanismo do tema (Alpine store "xCartHelper"), atualizando barra, itens e contador.
 */
(function () {
  if (window.Eurus && window.Eurus.loadedScript) {
    if (window.Eurus.loadedScript.has('barra-brinde.js')) return;
    window.Eurus.loadedScript.add('barra-brinde.js');
  }

  var configEl = document.getElementById('BarraBrindeConfig');
  if (!configEl) return;

  var cfg;
  try {
    cfg = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }
  if (!cfg) return;

  var bb = cfg.bb || {};
  var bb2 = cfg.bb2 || {};
  var pairs = cfg.pairs || [];
  var excludedProductIds = cfg.excludedProductIds || [];

  // "has*" = regra tem produto/valor configurados (roda mesmo desativada, so
  // para poder REMOVER um brinde que ja estava no carrinho de antes).
  var hasBb = !!(bb.giftVariantId && bb.thresholdCents > 0);
  var hasBb2 = !!(bb2.giftVariantId && bb2.minUnits > 0);
  var hasPairs = pairs.length > 0;
  if (!hasBb && !hasBb2 && !hasPairs) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SYNC_HEADER = 'X-BB-Sync';
  var nativeFetch = window.fetch.bind(window);

  function getCart() {
    return nativeFetch(ROOT + 'cart.js', {
      headers: { Accept: 'application/json' },
    }).then(function (r) {
      return r.json();
    });
  }

  function postJSON(path, body) {
    // Usa nativeFetch (referencia capturada antes do wrapper abaixo), entao
    // esta chamada nunca passa pelo wrapper. O header SYNC_HEADER fica aqui
    // so por seguranca, caso o wrapper um dia troque para window.fetch.
    var headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };
    headers[SYNC_HEADER] = '1';
    return nativeFetch(ROOT + path, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(body),
    });
  }

  function cartHelper() {
    return window.Alpine && typeof Alpine.store === 'function' ? Alpine.store('xCartHelper') : null;
  }

  // Busca o HTML das secoes aqui e entrega pronto ao tema: chamar
  // reRenderSections() sem argumento monta uma URL invalida fora da pagina /cart.
  function refreshCartUI() {
    var helper = cartHelper();
    if (!helper || typeof helper.getSectionsToRender !== 'function') return Promise.resolve();

    var ids = helper.getSectionsToRender().map(function (s) {
      return s.id;
    });
    var requests = [];
    // A Section Rendering API aceita no maximo 5 secoes por chamada.
    for (var i = 0; i < ids.length; i += 5) {
      requests.push(
        nativeFetch(window.location.pathname + '?sections=' + ids.slice(i, i + 5).join(',')).then(function (r) {
          return r.json();
        })
      );
    }
    return Promise.all(requests).then(function (parts) {
      var sections = {};
      parts.forEach(function (part) {
        Object.keys(part).forEach(function (id) {
          sections[id] = part[id];
        });
      });
      return helper.reRenderSections(sections);
    });
  }

  // Decide add/remove/corrige quantidade para UM brinde (variantId) dado se
  // ele deveria estar no carrinho agora (`qualifies`). Empilha o resultado em
  // `toAdd` (array, vira um unico cart/add.js) e `updates` (um unico
  // cart/update.js por key). Reaproveitada pelas 3 regras.
  function planGift(cart, variantId, giftAvailable, qualifies, toAdd, updates) {
    if (!variantId) return;
    var lines = cart.items.filter(function (i) {
      return i.variant_id === variantId;
    });
    if (qualifies && giftAvailable) {
      if (lines.length === 0) {
        toAdd.push({ id: variantId, quantity: 1, properties: { _brinde_automatico: 'true' } });
      } else if (lines.length > 1 || lines[0].quantity !== 1) {
        lines.forEach(function (l, idx) {
          updates[l.key] = idx === 0 ? 1 : 0;
        });
      }
    } else if (lines.length > 0) {
      lines.forEach(function (l) {
        updates[l.key] = 0;
      });
    }
  }

  // Soma as unidades "elegiveis" do carrinho para a regra de quantidade de
  // itens: ignora brindes automaticos, embalagem de presente, seguro de
  // frete e qualquer linha "vinculada" a outra (personalizacao, gravacao,
  // combos do customize_picker) — o tema marca essas com a propriedade
  // "For" (ver assets/product-cart.js). Kits marcados contam em dobro.
  function isLinkedAddon(item) {
    return !!(item.properties && item.properties['For']);
  }
  function eligibleUnits(cart) {
    var total = 0;
    cart.items.forEach(function (item) {
      if (excludedProductIds.indexOf(item.product_id) !== -1) return;
      if (isLinkedAddon(item)) return;
      var weight = bb2.doubleCountProductIds && bb2.doubleCountProductIds.indexOf(item.product_id) !== -1 ? 2 : 1;
      total += item.quantity * weight;
    });
    return total;
  }

  // Um ciclo: le o carrinho uma vez, avalia as 3 regras e dispara no maximo
  // um cart/add.js e um cart/update.js, nao um por regra. syncGift e
  // idempotente: rodar duas vezes seguidas na mesma foto do carrinho nao
  // produz nenhuma chamada extra.
  function syncGift() {
    return getCart().then(function (cart) {
      var toAdd = [];
      var updates = {};

      // Varias regras podem usar o MESMO produto-brinde. Junta tudo por
      // variante antes de decidir: o brinde fica se QUALQUER regra que usa ele
      // estiver atingida. Sem isso uma regra adicionava e a outra removia.
      var wanted = {};
      function want(variantId, available, qualifies) {
        if (!variantId) return;
        var entry = wanted[variantId] || (wanted[variantId] = { id: variantId, keep: false });
        if (qualifies && available) entry.keep = true;
      }

      if (hasBb) {
        var bbSubtotal = cart.items.reduce(function (sum, item) {
          return item.variant_id === bb.giftVariantId ? sum : sum + item.final_line_price;
        }, 0);
        want(bb.giftVariantId, bb.giftAvailable, !!bb.enable && bbSubtotal >= bb.thresholdCents);
      }

      if (hasBb2) {
        want(bb2.giftVariantId, bb2.giftAvailable, !!bb2.enable && eligibleUnits(cart) >= bb2.minUnits);
      }

      if (hasPairs) {
        pairs.forEach(function (pair) {
          var triggerPresent = cart.items.some(function (item) {
            return item.product_id === pair.triggerProductId;
          });
          want(pair.giftVariantId, pair.giftAvailable, triggerPresent);
        });
      }

      Object.keys(wanted).forEach(function (k) {
        var entry = wanted[k];
        planGift(cart, entry.id, true, entry.keep, toAdd, updates);
      });

      // Brinde adicionado por este script cujo produto saiu da configuracao
      // (trocaram o produto-brinde no editor): nenhuma regra cuida mais dele.
      cart.items.forEach(function (item) {
        var auto = item.properties && item.properties._brinde_automatico;
        if (auto && !wanted[item.variant_id]) updates[item.key] = 0;
      });

      var hasUpdates = Object.keys(updates).length > 0;
      if (toAdd.length === 0 && !hasUpdates) return false;

      var addPromise = toAdd.length
        ? postJSON('cart/add.js', { items: toAdd }).then(function (r) {
            if (!r.ok) {
              return r.json().then(function (err) {
                console.warn('[barra-brinde] nao foi possivel adicionar brinde(s)', err && err.description);
              });
            }
          })
        : Promise.resolve();

      return addPromise.then(function () {
        if (!hasUpdates) return true;
        return postJSON('cart/update.js', { updates: updates }).then(function () {
          return true;
        });
      });
    });
  }

  var timer = null;
  var queue = Promise.resolve();

  // O tema altera linhas do carrinho pelo indice (line). Enquanto o brinde entra
  // ou sai os indices mudam, entao seguramos as acoes do tema com a mesma
  // trava que ele ja usa (window.updatingCart) ate a lista ser re-renderizada.
  function runSync() {
    var helper = cartHelper();
    var ready = helper && typeof helper.waitForCartUpdate === 'function' ? helper.waitForCartUpdate() : Promise.resolve();
    return ready
      .then(function () {
        window.updatingCart = true;
        return syncGift();
      })
      .then(function (changed) {
        if (changed) return refreshCartUI();
      })
      .catch(function (e) {
        console.error('[barra-brinde]', e);
      })
      .then(function () {
        window.updatingCart = false;
      });
  }

  function scheduleSync() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      queue = queue.then(runSync);
    }, 200);
  }

  // Reage a qualquer chamada que altere o carrinho: tema, PDP, Selleasy,
  // order bump, upsell etc. Ignora as proprias chamadas (SYNC_HEADER).
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var mine = !!(init && init.headers && init.headers[SYNC_HEADER]);
    var result = originalFetch.apply(this, arguments);
    if (CART_MUTATION.test(url) && !mine) {
      result.then(scheduleSync).catch(function () {});
    }
    return result;
  };

  // Alguns apps (ex.: Selleasy, order bumps) usam XMLHttpRequest em vez de
  // fetch para mexer no carrinho. Cobre esse caso tambem.
  var originalOpen = window.XMLHttpRequest.prototype.open;
  var originalSend = window.XMLHttpRequest.prototype.send;
  window.XMLHttpRequest.prototype.open = function (method, url) {
    this._bbUrl = url;
    return originalOpen.apply(this, arguments);
  };
  window.XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    var url = (xhr._bbUrl || '').toString();
    if (CART_MUTATION.test(url)) {
      xhr.addEventListener('loadend', scheduleSync);
    }
    return originalSend.apply(this, arguments);
  };

  document.addEventListener('eurus:cart:items-changed', scheduleSync);
  window.addEventListener('pageshow', scheduleSync); // inclui volta via bfcache

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync);
  } else {
    scheduleSync();
  }
})();
